<template>
  <div data-testid="payments-container" class="max-w-screen-xl mx-auto px-4">
    <h2 :data-testid="testId(['payments', 'title'])" class="mb-0 uppercase">
      {{ component.title }}
    </h2>
    <div data-testid="payment-methods" class="flex flex-row flex-wrap mb-28">
      <strapi-image
        v-for="paymentMethod in component.paymentMethods"
        :key="paymentMethod.id"
        :image="paymentMethod.image"
        :alt="paymentMethod.title"
        class="w-full md:w-1/2 lg:w-1/4 mt-8 text-center h-12 opacity-100"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { StrapiPaymentMethod } from '~/apollo/types/types';
import testId from '~/helpers/testid';

defineProps<{
  component: StrapiPaymentMethod;
}>();
</script>
